module.exports = __webpack_public_path__ + "img/ft-shapes.0670f786.svg";